import { render, staticRenderFns } from "./trv4506treport.vue?vue&type=template&id=354e88e9"
import script from "./trv4506treport.vue?vue&type=script&lang=js"
export * from "./trv4506treport.vue?vue&type=script&lang=js"
import style0 from "./trv4506treport.vue?vue&type=style&index=0&id=354e88e9&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports